import React from 'react';
import SelexSolNavbar from "./CommonC/SelexSolNavbar";

function SelexCIP() {
  return (
    <div>
         <SelexSolNavbar isLoggedIn={!!sessionStorage.getItem("usertoken")}/>

         <iframe
      src="/SelexCIP/index.html"
      width="100%"
      height="750px"
      style={{ border: "none" }}
      title="HTML Page"
    />
    </div>
  )
}

export default SelexCIP